import { useContext } from "react";

import ReportStatusContext from "../context/ReportStatusProvider";

const useReportStatus = () => {
  return useContext(ReportStatusContext);
}

export default useReportStatus;